export enum ScanState {
  Success = 'success',
  SuccessPartial = 'success partial',
  Failed = 'failed',
  FailedPartial = 'failed partial',
  InQueue = 'in queue',
  InProgress = 'in progress',
  Unknown = 'unknown',
}
